// blog data

export const Blogs = [
    {
        id:1,
        name:"todo list",
        tags:["react","html","styled-components"],
        date: "A simple todo list developed using html, css and javascript to organize and prioritize tasks ",
        imgSrc:"https://4.bp.blogspot.com/--IWVg2byUho/WN97i2CsENI/AAAAAAAACLI/KBwGxwt-2zwUiUyvC9f-x63uypeKAZfggCLcB/s1600/HTML_VS_CSS.jpg",
        link:"https://tpoornashree.github.io/itinerary-list/"
    },
    {
        id:2,
        name:"Instagram UI using tailwind css",
        tags:["react","styled-components"],
        date:"Instead of opinionated predesigned components, Tailwind provides low-level utility classes that let you build completely custom designs without ever leaving your HTML.",
        imgSrc:"https://d1jnx9ba8s6j9r.cloudfront.net/blog/wp-content/uploads/2019/06/HTML-vs-CSS-vs-JavaScript-512x300.png",
        link:"https://tpoornashree.github.io/IG-ui-with-tailwind/"
    },
    {
        id:3,
        name:" website displays the list of movies that released all over the world",
        tags:["api","html","css"],
        date:"The heart of the project is the information that are displayed. For this I used an API which provides a fast, consistent and reliable way to get third party data.",
        imgSrc:"https://qph.fs.quoracdn.net/main-qimg-d9290772940ad7961a810e3777385946",
        link:"https://tpoornashree.github.io/find-the-best-movies-website/"
    },
    {
        id:4,
        name:"A simple Quiz Website developed using html, css and javascript",
        tags:["css","html","javascript"],
        date:"26 May, 2021",
        imgSrc:"https://wallpapercave.com/wp/wp2465902.jpg",
        link:"https://tpoornashree.github.io/quiz-yourself-with-reactjs/"
    },
    {
        id:5,
        name:"Whatsapp UI",
        tags:["css","html","web-development"],
        date:"Whatsapp UI with style.css index.html and some images.",
        imgSrc:"https://i.pinimg.com/736x/72/88/b5/7288b5c821d3c1064643c23de28653ee.jpg",
        link:"https://tpoornashree.github.io/text-me-on-whatsapp-clone"
    },
    {
        id:6,
        name:"spotify ui",
        tags:["html","css"],
        
        imgSrc:"https://qph.fs.quoracdn.net/main-qimg-006373d357a1f4bddb4c33ea18a393c3",
        link:"https://tpoornashree.github.io/play-the-music-non-stop/"

    },
   
    {
        id:7,
        name:"facebook like UI",
        tags:["css","html","javascript"],
        
        imgSrc:"https://i.stack.imgur.com/B3R8w.png",
        link:"https://tpoornashree.github.io/facebook-like-ui/"
    },
    {
        id:8,
        name:"Insta UI with features like viewing stories and viewing each post.",
        tags:["css","html","JS"],
        
        imgSrc:"https://www.kanhasoft.com/assets/images/mobile-application.png",
        link:"https://tpoornashree.github.io/insta-grammer-ui/"
    },
  
] 